export default __webpack_public_path__ + "static/media/PM.a28d9340.webp";